<app-navigation></app-navigation>
<div class="container main-container" [ngClass]="{'container-wide': useWideFormat, 'no-shrink': noShrink}">
  <app-spinner></app-spinner>
  <router-outlet></router-outlet>
</div>
<app-toasts aria-live="polite" aria-atomic="true"></app-toasts>
<app-modal></app-modal>